import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader2, QrCode, Store } from 'lucide-react';
import { apiGetInvoiceInfo } from '@/services/api';
import { storeRoute } from '@/lib/routes';

export default function InvoicePage() {
  const navigate = useNavigate();
  const { invoiceCode } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    apiGetInvoiceInfo(invoiceCode)
      .then(setInvoice)
      .catch((e) => {
        const detail = e.response?.data?.detail;
        setError(typeof detail === 'string' ? detail : 'Invoice not found');
      })
      .finally(() => setLoading(false));
  }, [invoiceCode]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
        <div className="max-w-md w-full rounded-2xl border border-border bg-card p-6 text-center space-y-3">
          <h1 className="text-xl font-bold">Invoice</h1>
          <p className="text-sm text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#faf5f5]">
      <div className="max-w-md w-full rounded-2xl border border-border bg-white p-6 space-y-4">
        <div className="flex items-center gap-2">
          <QrCode className="w-5 h-5 text-brand" />
          <h1 className="text-xl font-bold">Invoice QR</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          Invoice <span className="font-semibold text-foreground">{invoice.invoice_code}</span>
        </p>
        <div className="rounded-xl border border-border p-4 space-y-1">
          <p className="text-sm">Restaurant: <span className="font-semibold">{invoice.restaurant_name}</span></p>
          <p className="text-sm">Amount: <span className="font-semibold">${Number(invoice.amount || 0).toFixed(2)}</span></p>
          <p className="text-sm">Points: <span className="font-semibold">{invoice.points}</span></p>
          <p className="text-sm">Status: <span className={`font-semibold ${invoice.is_redeemed ? 'text-red-500' : 'text-emerald-600'}`}>{invoice.is_redeemed ? 'Redeemed' : 'Available'}</span></p>
        </div>
        <button
          onClick={() => navigate(storeRoute(invoice.merchant_id))}
          className="w-full h-11 rounded-xl gradient-brand-btn font-semibold text-sm flex items-center justify-center gap-2"
          data-testid="invoice-open-store-btn"
        >
          <Store className="w-4 h-4" />
          Open Restaurant Loyalty App
        </button>
      </div>
    </div>
  );
}
